import type { ApprovalRequestSource, ApprovalStatus, ObjectType } from './types';

// České popisky stavů žádosti.
export const STATUS_LABELS: Record<ApprovalStatus, string> = {
  draft: 'Rozpracováno',
  pending: 'Čeká na schválení',
  approved: 'Schváleno',
  rejected: 'Zamítnuto',
};

// České popisky typů verzovaných entit (klíč = Django model název, jak jej vrací API).
export const OBJECT_TYPE_LABELS: Record<ObjectType, string> = {
  solution: 'Řešení',
  product: 'Výrobek',
  unit: 'Jednotka',
  biblio: 'Bibliografie',
  propertydefinition: 'Vlastnost',
  technicalreportitem: 'Položka technické zprávy',
  professionbond: 'Profesní vazba',
  setpropertydefinition: 'Sada vlastností',
  settechnicalreportitem: 'Sada technických zpráv',
};

// České popisky zdroje žádosti.
export const REQUEST_SOURCE_LABELS: Record<ApprovalRequestSource, string> = {
  company_new: 'Nová firemní',
  community_adoption: 'Převzato z komunity',
  legacy_backfill: 'Historický import',
};

// Generický číselník klasifikací pro PickClassificationModal
// (PanelWithClassification skládá `/api/v1/classification/${url}`).
export const CLASSIFICATION_TREE_URL = 'left-panel/';
